<jqxWindow #form [theme]="theme" [position]="getFormPos(form)" [zIndex]="90" [width]="1000" [height]="480"
    [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true" [resizable]="false" (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Cerradura')}}
    </div>
    <div class="form" style="float:left; overflow-x: hidden;">
        <div style="width: 100%; height: 410px;">
            <jqxGrid #myGrid [theme]="theme" [width]="'100%'" [height]="'100%'" [source]="dataAdapter"
                [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                [columns]="columns" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                [altrows]="true" [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [enabletooltips]="true" [editable]="false" (onRowclick)="onRowClick($event)"
                [groupable]="true" [selectionmode]="'checkbox'" (onRowselect)="onSelect($event)"
                (onRowunselect)="onUnSelect($event)">
            </jqxGrid>
        </div>
        <jqxButton style="float: left; margin-left: 5px; margin-top: 5px;" [width]="100" [height]="26"
            [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/localizar.png'"
            [value]="translate('Centrar')" (onClick)="onPosicionar()">
        </jqxButton>
        <jqxButton style="float: left; margin-left: 5px; margin-top: 5px;" [width]="142" [height]="26"
            [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" [imgSrc]="'/assets/images/localizar.png'"
            [value]="translate('Pedir_localizacion')" (onClick)="onLocalizar()">
        </jqxButton>
    </div>
</jqxWindow>